import loadable from '@loadable/component';

import LoadingPage from '../../components/LoadingPage';

const LoadableInvoicingPage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadableInvoicingPage;
